import carDrive from "@/data/car-drive/car-drive.data";
import faullpageOptions from "@/data/fullpage-options";

const state = {
  text: carDrive,
  mainSliderActiveIndex: 0,
  innovationSliderActiveIndex: 0,
  mainSlider: {
    loop: true,
    breakpoints: {
      767: {
        autoHeight: true
      }
    }
  },
  innovationsSlider: {
    loop: false,
    simulateTouch: false,
    followFinger: false,
    allowTouchMove: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    breakpoints: {
      767: {
        autoHeight: true
      }
    }
  },
  options: faullpageOptions
};

const getters = {
  carDrive: (state: {}) => {
    return state;
  }
};

const mutations = {
  changeSliderPage(state: any, payload: number) {
    state.mainSliderActiveIndex = payload;
  },
  changeInnovationSliderPage(state: any, payload: number) {
    state.innovationSliderActiveIndex = payload;
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
